// about vue
// The MIT License (MIT)
//
// Copyright (c) 2018-present, Yuxi (Evan) You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

// about bootstrap-vue
// The MIT License (MIT)

// Copyright (c) BootstrapVueNext

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

// oss一覧
import { createApp } from 'vue';
import BootstrapVueNext from "bootstrap-vue-next";
import DateRangePicker from "vue3-daterange-picker";

// その他外部ファイル一覧
import App from './App.vue';
import router from './router';
import store from './store';
import api from './common/api';
import alert from './share/alert';
import dialog from './share/plugins/dialog';
import EventBus from './share/plugins/dialog/eventBus';
import startInterval from './share/plugins/startInterval';
import setInterval from './share/plugins/SetInterval';
import handler from './share/util/apiResultValidator';
import logWrapper from './share/logWrapper';
import notifyLogs from './share/util/notifyLogs';
import I18nPlugin from './share/plugins/I18nWrapper';
import util from './share/util/utils';
import i18n from './i18n/i18n';

// 本来このコンポーネントは使用してほしくない(詳細はShowLessBOverlayの中身を確認)
import showLessBOverlay from './share/components/vue/ShowLessBOverlay';

// IE対応
require('./share/polyfillForIe11.js');

import 'bootstrap/scss/bootstrap.scss';
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
// 独自カスタム用の scss 定義
import './share/framework/scss/bootstrap-custom.scss';
import './share/framework/scss/vue2-daterange-picker-custom.scss';
import './share/ssm5-common-style.scss';

const Vue = createApp(App);

Vue.config.productionTip = false;

// Vueで発生したエラーをキャッチする
/* eslint-disable no-console */
Vue.config.errorHandler = function (err, vm, info) {
  logWrapper.log('err : ', err);
  logWrapper.log('vm  : ', vm);
  logWrapper.log('info: ', info);
  notifyLogs.error('VueHandler', err);
};

// dialog の bus を追加
const $bus = new EventBus();
Vue.provide('$bus', $bus);
Vue.config.globalProperties.$bus = $bus;

Vue.use(i18n);
Vue.config.globalProperties.$te = i18n.global.te;

Vue.use(router);
Vue.use(store);
Vue.use(I18nPlugin);
Vue.use(dialog);
Vue.use(BootstrapVueNext);
Vue.use(startInterval);
Vue.use(setInterval);
Vue.component('DateRangePicker', DateRangePicker);
Vue.component('ShowLessBOverlay', showLessBOverlay);
Vue.mount('#app');

api.init('repro');
alert.setVariantType('secondary');
handler.init('execute');

// エラーをキャッチする
window.addEventListener("error", event => {
  logWrapper.log('event listener - error: ', event);
  notifyLogs.error("error", event.error);
  notifyLogs.currentUserAgent(window.navigator.userAgent);
});

// Vunhandledrejectionエラーをキャッチする
window.addEventListener("unhandledrejection", event => {
  logWrapper.log('event listener - unhandledrejection: ', event);
  notifyLogs.unhandledrejection(event);
  notifyLogs.currentUserAgent(window.navigator.userAgent);
});

// Hook for handling quotes and backslash
document.onkeydown = (event) => {
  return util.checkSSM5ValidCharacters(event);
};

document.onpaste = (event) => {
  return util.checkSSM5ValidPaste(event);
};